module.exports = __webpack_public_path__ + "img/LOGO_SVG_v2.aeb186a9.svg";